import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet,
    Dimensions,
    ScrollView
} from 'react-native';

import {
    JDText,
    JDTouchable,
    JDImage
} from '@jdreact/jdreact-core-lib';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import { pt, is_web } from '../../../common/utils';

class DownLayer extends PureComponent {
        constructor(props) {
        super(props);
        this.state = {
            currentDiscountState: {
                discountName: '筛选',
                discountId: '0'
            }
        }
    }
    componentDidMount(){
        this.setState({
            currentDiscountState: this.props.currentDiscount
        })
    }
    componentDidUpdate(pre, q){
        if(pre.currentSearchType !== this.props.currentSearchType){
            this.setState({
                currentDiscountState: {
                    discountName: '筛选',
                    discountId: '0'
                }
            })
        }
    }
    static defaultProps = {
        currentSearchType: null,
        currentRegion: {
            regionName: '全城',
            regionId: 0
        },
        currentBrand: {
            brandName: '品牌',
            brandId: 0
        },
        currentDistance: {
            distanceName: '距离',
            distanceId: 0
        },
        currentDiscount: {},
        regionList: [],
        brandList: [],
        distanceList: [],
        discountList: [],
        govSubsidyText: '',
        govSubsidyTag: '',
        indexFlag: true,
        isShowResult: false,
        searchCinema: () => {},
        closeLayer: () => {}
    }
    render() {
        const { isShowResult, regionList, brandList, distanceList, indexFlag, currentRegion, currentBrand, currentDistance, currentSearchType, discountList, govSubsidyText, govSubsidyTag } = this.props;
        const { currentDiscountState } = this.state;
        const { regionId } = currentRegion;
        const { brandId } = currentBrand;
        const { distanceId } = currentDistance;
        return (
                isShowResult ? <JDTouchable onPress={this.props.closeLayer} activeOpacity={1}>
                <View style={indexFlag ? st._result : st.result}>
                    <View style={!is_web ? {maxHeight: pt(280)} : {height: pt(280)}}>
                        <ScrollView 
                            bounces={false}
                            contentContainerStyle={{
                                backgroundColor: '#fff',
                                paddingLeft: pt(9),
                                paddingRight: pt(11)}}>
                        {
                            currentSearchType === 'region' && regionList.map((v, i) => {
                                return (
                                    <JDTouchable key={i} onPress={() => {this._searchCinema(v)}}>
                                        <View style={st.result_item}>
                                            {
                                                v.regionId === regionId ? <View style={st.current_item_l}>
                                                    <JDImage style={st.right_img} resizeMode='contain' source={img.rightImg}></JDImage>
                                                    <JDText style={st.result_item_current}>{v.regionName}</JDText>
                                                </View> : <View>
                                                    <JDText style={st.result_item_text}>{v.regionName}</JDText>
                                                </View>
                                            } 
                                            <JDText style={st.reault_num}>{v.cinemaCount}</JDText>
                                        </View>
                                    </JDTouchable>
                                )
                            })
                        }
                        {
                            currentSearchType === 'brand' && brandList.map((v, i) => {
                                return (
                                    <JDTouchable key={i} onPress={() => {this._searchCinema(v)}}>
                                        <View style={st.result_item}>
                                            {
                                                v.brandId === brandId ? <View style={st.current_item_l}>
                                                    <JDImage style={st.right_img} resizeMode='contain' source={img.rightImg}></JDImage>
                                                    <JDText style={st.result_item_current}>{v.brandName}</JDText>
                                                </View> : <View>
                                                    <JDText style={st.result_item_text}>{v.brandName}</JDText>
                                                </View>
                                            } 
                                            <JDText style={st.reault_num}>{v.cinemaCount}</JDText>
                                        </View>
                                    </JDTouchable>
                                )
                            })
                        }
                        {
                            currentSearchType === 'distance' && distanceList.map((v, i) => {
                                return (
                                    <JDTouchable key={i} onPress={() => {this._searchCinema(v)}}>
                                        <View style={st.result_item}>
                                            {
                                                v.distanceId === distanceId ? <View style={st.current_item_l}>
                                                    <JDImage style={st.right_img} resizeMode='contain' source={img.rightImg}></JDImage>
                                                    <JDText style={st.result_item_current}>{v.distanceName}</JDText>
                                                </View> : <View>
                                                    <JDText style={st.result_item_text}>{v.distanceName}</JDText>
                                                </View>
                                            } 
                                            {/* <JDText style={st.reault_num}>{v.cinemaCount}</JDText> */}
                                        </View>
                                    </JDTouchable>
                                )
                            })
                        }
                        {
                            currentSearchType === 'discount' && <View style={st.dis_cont}>
                                <JDText style={st.dis_title}>活动优惠</JDText>
                                <View style={st.dis_list_cont}>
                                    {
                                        discountList?.filter(item => item.discountId !== '0').map((v, i) => {
                                            let itemShowText = '';
                                            if (v.discountId === '1' && govSubsidyTag && govSubsidyTag === "DBC" && govSubsidyText) {
                                                itemShowText = govSubsidyText;
                                            } else {
                                                itemShowText = v.discountName;
                                            }
                                            return(
                                                <JDTouchable style={{flex: 1}} key={i} onPress={() => {this.setState({currentDiscountState: v})}}>
                                                    <View style={[st.dis_item, currentDiscountState.discountId === v.discountId? st.dis_current_item : '']}>
                                                        <JDText style={[st.dis_item_text, currentDiscountState.discountId === v.discountId? st.dis_item_current_text : '']}>{itemShowText}</JDText>
                                                    </View>
                                                </JDTouchable>
                                            )
                                        })
                                    }
                                </View>
                                <View style={st.btn_wrap}>
                                    <View style={ st.btn }>
                                        <JDTouchable onPress={ this.reset }>
                                            <JDText style={ st.btn_txt }>重置</JDText>
                                        </JDTouchable>
                                    </View>
                                    <LinearGradient
                                        colors={ ['#FF5856', '#FF0400'] }
                                        style={ [st.btn, st.sub_btn] }
                                        start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                                        <JDTouchable style={ st.sub } onPress={() => {this._searchCinema(currentDiscountState)}}>
                                            <JDText style={ [st.btn_txt, st.sub_txt] }>完成</JDText>
                                        </JDTouchable>

                                    </LinearGradient>
                                </View>
                            </View>
                            
                        }
                        </ScrollView>
                    </View>
                </View>
            </JDTouchable> : null
        )
        
    }
    // 按区域筛选影院
    _searchCinema = item => {
        console.log('item', item)
        this.props.searchCinema(item);
        this.props.closeLayer();
    }
    //筛选重置
    reset = () => {
        this.setState({
            currentDiscountState: {
                discountName: '筛选',
                discountId: '0'
            }
        })
    }
}
const img = {
    rightImg: require('./img/rightImg.png'),
    triangle: require('./img/triangle.png')
}
const st = StyleSheet.create({
    t_item: {
        height: pt(36),
        marginLeft: pt(41),
        flexDirection: 'row',
        alignItems: 'center'
    },
    result: {
        // flex: 1,
        width: '100%',
        height: Dimensions.get('window').height - (is_web ? pt(74): pt(36)),
        backgroundColor: 'rgba(37,37,37,.7)'
    },
    _result: {
        // flex: 1,
        width: '100%',
        height: Dimensions.get('window').height - (is_web ? pt(80): pt(36)),
        backgroundColor: 'rgba(37,37,37,.7)'
    },
    result_item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: pt(40),
        alignItems: 'center',
        borderBottomWidth: pt(1),
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    current_item_l: {
        flexDirection: 'row'
    },
    right_img: {
        width: pt(19),
        height: pt(19)
    },
    result_item_text: {
        color: '#252525',
        fontSize: pt(14),
        paddingLeft: pt(26)
    },
    result_item_current: {
        color: '#E2231A',
        fontSize: pt(14),
        paddingLeft: pt(7)
    },
    reault_num: {
        color: '#898989',
        fontSize: pt(12)
    },
    dis_cont: {
        width: '100%',
        height: pt(146),
        paddingTop: pt(15),
        paddingBottom: pt(12),
        paddingLeft: pt(2),
        paddingRight: pt(2)
    },
    dis_title: {
        color: '#1A1A1A',
        fontSize: pt(14),
        fontFamily: 'PingFangSC-Medium',
        fontWeight: 600,
        marginBottom: pt(12.5),
        height: pt(14),
        lineHeight: pt(16)
    },
    dis_list_cont: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: pt(8)
    },
    dis_item: {
        height: pt(28),
        backgroundColor: '#F5F6FA',
        borderRadius: pt(4),
        alignItems: 'center',
        justifyContent: 'center'
        
    },
    dis_current_item: {
        backgroundColor: '#FFF0F4'
    },
    dis_item_text: {
        color: '#1A1A1A',
        fontSize: pt(12),
        fontFamily: 'PingFangSC-Regular',
        fontWeight: 400,
        textAlign: 'center'
    },
    dis_item_current_text: {
        color: '#FF0F23',
        fontFamily: 'PingFangSC-Medium',
        fontWeight: 500,
    },
    btn_wrap: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: pt(24.5),
        gap: pt(10)
    },
    btn: {
        // width: pt(165),
        flex: 1,
        height: pt(40),
        borderRadius: pt(6),
        backgroundColor: '#F6F6F6'
    },
    btn_txt: {
        color: '#1A1A1A',
        fontSize: pt(16),
        fontFamily: 'PingFangSC-Regular',
        fontWeight: 400,
        textAlign: 'center',
        lineHeight: pt(40)
    },
    sub_txt: {
        color: '#FFFFFF',
        fontFamily: 'PingFangSC-Semibold',
        fontWeight: 600,
    }

});

export default DownLayer;